import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Stack, Typography } from 'investira.react.components';
import { displays } from 'investira.react.lib';
import { validators } from 'investira.sdk';
import { PessoaImage, ModalInfo } from '../../molecules';

const METRICAS = {
  cs: 'Capital Social',
  pl: 'Patrimônio Líquido',
  market_value: 'Valor de Mercado'
};

const EmpresaMetricasInfo = memo(props => {
  const { data, metrica, onClick, showSectors, sectorsContent, selectedId, ...otherProps } = props;

  return (
    <Stack
      direction="row"
      flexGrow={1}
      spacing={2}
      alignItems="center"
      onClick={onClick}
      sx={{
        px: 2,
        py: 1.5,
        cursor: 'pointer',
        textDecoration: 'none',
        color: 'inherit',
        '&:hover': {
          backgroundColor: 'background.main'
        },
        ...(selectedId &&
          data.pessoa_id === selectedId && {
            backgroundColor: 'action.selected',
            '&:hover': {
              backgroundColor: 'action.selected'
            }
          })
      }}
      {...otherProps}>
      <Stack alignSelf="flex-start">
        <PessoaImage
          logoPessoaId={data.logo_pessoa_id}
          alt={data.pessoa_fantasia || data.pessoa}
          hasLogo={data.logo_ok}
          size={36}
        />
      </Stack>

      <Stack flexGrow={1} spacing={0.5}>
        <Typography variant="body2" color="textPrimary" sx={{ fontWeight: 600 }}>
          {data.pessoa_fantasia || data.pessoa}
        </Typography>
        <Stack direction="row" spacing={1} alignItems="center">
          {data.pessoa_fantasia && data.pessoa !== data.pessoa_fantasia && (
            <Typography variant="caption" color="textSecondary">
              {data.pessoa}
            </Typography>
          )}
          {data.cnpj && (
            <Typography variant="caption" color="textSecondary">
              {displays.cnpj(data.cnpj)}
            </Typography>
          )}
        </Stack>
        {!validators.isNull(data.metrica?.[metrica]) && (
          <Stack direction="row" spacing={0.5} alignItems="baseline">
            <Typography variant="caption" color="textSecondary">
              {`${METRICAS[metrica]}:`}
            </Typography>
            <Typography variant="body2" color="textPrimary" sx={{ fontWeight: 600 }}>
              {new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL',
                notation: 'compact',
                maximumFractionDigits: 2
              }).format(data.metrica[metrica])}
            </Typography>
          </Stack>
        )}
      </Stack>
      {showSectors && sectorsContent && (
        <Stack onClick={e => e.stopPropagation()}>
          <ModalInfo
            label="Setores"
            value={data.top_setor}
            modalProps={{
              pessoaId: data.pessoa_id
            }}
            modalContent={sectorsContent}
            type="row"
            divider={false}
          />
        </Stack>
      )}
    </Stack>
  );
});

EmpresaMetricasInfo.propTypes = {
  data: PropTypes.object.isRequired,
  metrica: PropTypes.string,
  onClick: PropTypes.func,
  showSectors: PropTypes.bool,
  sectorsContent: PropTypes.elementType,
  selectedId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default EmpresaMetricasInfo;
